export default "__VITE_ASSET__COYRCw_V__"